















import { Component, Vue } from 'vue-property-decorator'

import Default from '../components/common/Default.vue'

@Component({ components: { Default } })
export default class Terms extends Vue {
  lastEditText = '2020年3月24日制定'
  terms = [
    {
      title: '第１条 適用',
      text: `
１．本規約は、本サービスの提供状況及び本サービスの利用に関する当社と会員との間の権利義務関係を定めることを目的とし、会員と当社との間の本サービスの利用に関わる一切の関係に適用されます。
２．当社が当社ウェブサイト上で掲載する本サービス利用に関するルールは、本規約の一部を構成するものとします。
３．本契約の内容と、前項のルールその他の本規約外における本サービスの説明等とが異なる場合は、本契約の規定が優先して適用されるものとします。
`
    },
    {
      title: '第２条 定義',
      text: `
本規約において使用する次の各号に掲げる用語の意味は、当該各号に定めるとおりとします。
• 「会員」―第３条に基づいて本サービスの利用者として登録がなされた個人または法人
• 「サービス利用契約」―本規約及当社と会員の間で締結する、本サービスるの利用契約
• 「知的財産権」―著作権、特許権、実用新案権、意匠権、商標権その他の知的財産権（それらの権利を取得し、またはそれらの権利につき登録等を出願する権利を含みます。）
• 「当社」―株式会社ノーパッケージ
• 「当社ウェブサイト」―そのドメインが【micoma.com】である、当社が運営するウェブサイト（理由の如何を問わず、当社のウェブサイトのドメインまたは内容が変更された場合は、当該変更後のウェブサイトを含みます。）
• 「micoma」―当社が運営する投稿まとめサービスの総称
• 「本サービス」―当社が提供する「micoma」を通じて提供されるすべてのサービス（理由の如何を問わずサービスの名称または内容が変更された場合は、当該変更後のサービスを含みます。）
`
    },
    {
      title: '第３条 会員登録',
      text: `
１．会員になることを希望する方（以下「登録希望者」といいます。）は、本規約を遵守することを承諾し、かつ当社の定める一定の情報（以下「登録事項」といいます。）を当社の定める方法で当社にて供することにより、本サービスの利用を申し込むものとします。当社は、会員の申込み内容に関して本人確認等のための資料の提出を求めることがあります。
２．当社は、当社の基準に従って、前項の規定に基づいて登録申請を行った登録希望者の登録の可否を判断し、当社が登録を認める場合にはその旨を登録申請者に通知し、登録希望者に対してアカウントを発行します。
３．前項に定める登録完了時に、当社と会員との間で本規約及び本サービスの利用に関する契約が成立し、会員は本サービスを本規約に従い利用することができるようになります。
４．当社は、第１項の規定により本サービスの利用申込みをした登録希望者が、以下の各号のいずれかに事由に該当する場合は、登録及び再登録を拒否することがあり、また拒否した理由について一切開示義務を負いません。
⑴ 当社に提供した登録事項の全部または一部につき虚偽、誤記または記載漏れがあった場合
⑵ 未成年者、成年被後見人、被保佐人または被補助人のいずれかであり、法定代理人、後見人、保佐人、補助人の同意等を得ていなかった場合
⑶ 反社会的勢力等（暴力団、暴力団員、右翼団体、反社会的勢力、その他これに準ずる者を意味します。以下同じ。）である、または資金提供その他の関与により反社会的勢力等の維持、運営もしくは経営に協力もしくは関与する等反社会的勢力等との何らかの交流もしくは関与を行っていると当社が判断した場合
⑷ 本サービスの利用申込みをした登録希望者が過去に規約違反等により、会員資格の取り消し、除名処分が行なわれていると当社が判断した場合
⑸ 当社の競合他社等が当社の業務内容を調査する目的で契約を行おうとしていることが判明した場合
⑹ 第９条に定める措置を受けたことがある場合
⑺ その他、当社が登録を適当でないと判断した場合
`
    },
    {
      title: '第４条 登録事項の変更',
      text: `
会員は、登録事項に変更のあった場合、すみやかに当社所定の手続きにより当社に届け出るものとします。この届出のない場合、当社は、登録事項の変更のないものとして取り扱うことができるものとします。
      `
    },
    {
      title: '第５条 ID・パスワードの管理',
      text: `
１．会員は、自己の責任において、会員登録後に当社が会員に付与するID・パスワードを適切に管理及び保管するものとし、その管理及び使用についての一切の責任を負うものとします。
２．会員は、ID及びパスワードを第三者に利用させ、または貸与、譲渡、名義変更、売買、質入等をすることをしてはならないものとします。
３．ID及びパスワード並びにID及びパスワードを入力した装置の管理不十分、使用上の過誤、第三者の使用等による不正使用及び損害の責任は会員が負うものとし、当社は一切責任を負いません。
４．会員は、定期的にパスワードを変更する義務があるものとし、その義務を怠ったことにより生じた損害に関する責任は会員が負うものとし、当社は一切責任を負いません。
`
    },
    {
      title: '第６条 禁止事項',
      text: `
会員は、本サービスの利用にあたり、以下の各号のいずれかに該当する行為または該当すると当社が判断する行為をしてはなりません。
(1) 法令に違反する行為または犯罪行為に関連する行為
(2) 当社、本サービスの他の利用者またはその他の第三者に対する詐欺または脅迫行為
(3) 公序良俗に反する行為
(4) 当社に連絡を止めて欲しいと要請がきたにも関わらず、停止しない強引な訪問や電話やSNSによる勧誘行為
(5) 当社、本サービスの他の利用者またはその他の第三者の知的財産権、肖像権、プライバシーの権利、名誉、その他の権利または利益を侵害する行為
(6) 本サービス内において、自己または第三者を通じて、以下に該当し、または該当すると当社が判断する情報を当社または本サービスの他の利用者に送信すること
• 過度に暴力的または残虐な表現を含む情報
• コンピューター・ウィルスその他の有害なコンピューター・プログラムを含む情報
• 真実でない情報
• 当社、本サービスの他の会員またはその他第三者の名誉・信用を傷つける表現を含む情報
• 過度にわいせつな表現、児童ポルノ、児童虐待に類する情報
• 差別を助長する表現を含む情報
• 反社会的な表現を含む情報
• 他人に不快感を与える表現を含む情報
• その他公序良俗に反する情報
(7) 本サービスのネットワークまたはシステム等に過度な負荷をかける行為
(8) 本サービスの運営を妨害するおそれのある行為
(9) 当社のネットワークまたはシステム等に不正にアクセスし、または不正なアクセスを試みる行為
(10) 第三者に成りすます行為
(11) 本サービスの他の利用者のIDまたはパスワードを利用する行為
(12) 当社が事前に許諾しない本サービス上での宣伝、広告、勧誘または営業行為
(13) 本サービスの他の利用者の情報の収集
(14) 本サービスの他の利用者またはその他の第三者に不利益、損害、不快感を与える行為
(15) 当社ウェブサイト上に掲載する本サービス利用に関するルールに抵触する行為
(16) 反社会的勢力等への利益供与
(17) 前各号の行為を直接または間接に惹起し、または容易にする行為
(18) その他、当社が不適切と判断する行為
`
    },
    {
      title: '第７条 本サービスの停止',
      text: `
１．当社は、以下のいずれかに該当する場合には、会員に事前に通知することなく、本サービスの全部または一部の提供を停止または中断することができるものとします。
(1) 本サービスに係るコンピューター・システムの点検または保守作業を緊急に行う場合
(2) コンピューター、通信回線等が事故により停止した場合
(3) 地震、落雷、火災、風水害、停電、天災地変などの不可抗力により本サービスの運営ができなくなった場合
(4) その他、当社が停止または中断を必要と判断した場合
２．当社は、前項に基づき当社が行った措置によって会員に生じた損害について一切の責任を負いません。
`
    },
    {
      title: '第８条 権利帰属',
      text: `
１．当社ウェブサイト及び本サービスに関する知的財産権は全て当社または当社にライセンスを許諾している者に帰属しており、本規約に基づいて本サービスを利用許諾したことによって、当社ウェブサイトまたは本サービスに関する当社または当社にライセンスを許諾している者の知的財産権の使用を許諾するものではありません。
２．会員は、投稿コンテンツについて、自らが投稿その他送信することについての適法な権利を有していること、及び投稿コンテンツが第三者の権利を侵害していないことについて、当社に対し表明し、保証するものとします。投稿コンテンツに、ユーザー以外の第三者が知的財産権を有している場合、必ず事前に権利者の使用許諾が必要となります。
3．会員は、当社及び当社から権利を承継しまたは許諾された者に対して著作者人格権を行使しないことに同意するものとします。
`
    },
    {
      title: '第９条 登録抹消等',
      text: `
１．当社は、会員が、以下の各号のいずれかの事由に該当する場合は、事前に通知または催告することなく、投稿コンテンツを削除しもしくは当該会員について本サービスの利用を一時的に停止し、または会員登録を抹消、もしくはサービス利用契約を解除することができます。
(1) 本規約のいずれかの条項に違反した場合
(2) 登録事項に虚偽の事実があることが判明した場合
(3) 支払停止もしくは支払不能となり、または破産手続開始、民事再生手続開始、会社更生手続開始、特別清算開始もしくはこれらに類する手続の開始の申立てがあった場合
(4) 当社からの問いあわせその他の回答を求める連絡に対して【30日】間以上応答がない場合
(5) 第３条第４項各号に該当する場合
(6) その他、当社が本サービスの利用、会員登録、またはサービス利用契約の継続を適当でないと判断した場合
２．前項各号のいずれかの事由に該当した場合、会員は、当社に対して負っている債務の一切について当然に期限の利益を失い、直ちに当社に対して全ての債務の支払を行わなければなりません。
３．当社は、本条に基づき当社が行った行為によって会員に生じた損害について一切の責任を負いません。
`
    },
    {
      title: '第１０条 退会',
      text: `
１．会員は、当社所定の方法で当社に通知することにより、本サービスから退会し、会員登録を抹消することができます。
２．会員は、退会にあたり、当社に対して負っている債務が有る場合は、当社に対して負っている債務の一切について当然に期限の利益を失い、直ちに当社に対して全ての債務の支払を行わなければなりません。
３．退会後の利用者情報の取扱いについては、第１４条の規定に従うものとします。
`
    },
    {
      title: '第１１条 本サービスの内容の変更・終了',
      text: `
１．当社は、当社の都合により、本サービスの内容を変更し、または提供を終了することができます。当社が本サービスの提供を終了する場合、当社は会員に事前に通知するものとします。
２．当社は、前項に基づき当社が行った措置によって会員に生じた損害について一切の責任を負いません。
      `
    },
    {
      title: '第１２条 保証の否認及び免責',
      text: `
１．当社は、本サービスが会員の特定の目的に適合すること、期待する機能・商品的価値・正確性・有用性を有すること、会員による本サービスの利用が会員に適用のある法令または業界団体の内部規則等に適合すること、投稿コンテンツの内容が正確であること、及び不具合が生じないことについて、何ら保証するものではありません。
２．当社は、当社による本サービスの提供の中断、停止、終了、利用不能または変更、会員が本サービスに送信したメッセージまたは情報の削除または消失、会員登録の抹消、本サービスの利用による機器の故障もしくは損傷、その他本サービスに関して会員が被った損害につき、賠償する責任を一切負わないものとします。
３．何らかの理由により当社が責任を負う場合であっても、当社は、前項の損害につき、金１万円を超えて賠償する責任を負わないものとし、また、付随的損害、間接損害、特別損害、将来の損害及び逸失利益にかかる損害については、賠償する責任を負わないものとします。
４．本サービスまたは当社ウェブサイトに関連して会員と他の会員または第三者との間において生じた取引、連絡、紛争等については、当社は一切責任を負いません。
`
    },
    {
      title: '第１３条 秘密保持',
      text: `
会員は、本サービスに関連して当社が会員に対して秘密に取り扱うことを求めて開示した非公知の情報について、当社の事前の書面による承諾がある場合を除き、秘密に取り扱うものとします。
      `
    },
    {
      title: '第１４条 個人情報等の取り扱いについて',
      text: `
１．当社による会員の利用者情報の取扱いについては、別途当社プライバシーポリシーの定めによるものとし、会員はこのプライバシーポリシーに従って当社が会員の利用者情報を取扱うことについて同意するものとします。
２．当社は、会員が当社に提供した情報、データ等を、個人を特定できない形での統計的な情報として、当社の裁量で、利用及び公開することができるものとし、会員はこれに異議を唱えないものとします。
`
    },
    {
      title: '第１５条 利用規約の変更',
      text: `
当社は、いつでも予告なく本規約を変更・追加することができるものとする。当社は、本規約を変更・追加した場合、会員に当該変更内容を通知するものとし、当該変更内容の通知するものとし、当該変更内容の通知後、会員が本サービスを利用した場合または２週間以内に登録抹消の手続をとらなかった場合には、会員は、本規約の変更に同意したものとみなします。
      `
    },
    {
      title: '第１６条 当社からの通知等',
      text: `
１．当社は、本サービスに関連して会員に通知または連絡（以下「通知等」といいます。）をする場合には、本サイトに掲示する方法または登録情報として登録された電子メールアドレス・住所に宛てて電子メール・文書を送信する方法など、当社が適当と判断する方法で実施します。
２．当社が前項の通知等を本サービスのホームページ上で行う場合は、当該通知等をホームページに掲載した日をもって、利用者に当該通知等が到達したものとみなします。
３．当社が第１項の通知等を電子メールで行う場合は、当社に登録されたメールアドレスにメールを送信することによってメールが通常到達すべきときに到達したものとします。会員が当社に届け出た事項に虚偽、過誤、不備があり、当社からの連絡事項が届かなったことによる損害について、当社は一切の責任を負いません。
`
    },
    {
      title: '第１７条 サービス利用契約上の地位の譲渡等',
      text: `
１．会員は、当社の書面による事前の承諾なく、サービス利用契約上の地位または本規約に基づく権利もしくは義務につき、第三者に対し、譲渡、移転、担保設定、その他の処分をすることはできません。
２．当社は本サービスにかかる事業を他社に譲渡した場合には、当該事業譲渡に伴いサービス利用契約上の地位、本規約に基づく権利及び義務並びに会員の登録事項その他の顧客情報を当該事業譲渡の譲受人に譲渡することができるものとし、会員は、かかる譲渡につき本項において予め同意したものとします。なお、本項に定める事業譲渡には、通常の事業譲渡のみならず、会社分割その他事業が移転するあらゆる場合を含むものとします。
`
    },
    {
      title: '第１８条 分離可能性',
      text: `
本規約のいずれかの条項またはその一部が、消費者契約法その他の法令等により無効または執行不能と判断された場合であっても、本規約の残りの規定及び一部が無効または執行不能と判断された規定の残りの部分は、継続して完全に効力を有するものとします。
`
    },
    {
      title: '第１９条（準拠法及び管轄裁判所）',
      text: `
１．本規約及びサービス利用契約の準拠法は日本法とします。
２．本規約またはサービス利用契約に起因し、または関連する一切の紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
`
    }
  ]
}
